import {
  FIELD_MEMBERS,
  FIELD_SET_COMMON_PAY_FREQUENCY,
} from './constants.fields';
import { WAGES_AND_INCOME_COMMON_FIELD_NAMES } from './constants.fields';

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.publicAid.title',
  description: 'afforda.wagesAndIncome.details.publicAid.subtitle',
  addButton: 'afforda.wagesAndIncome.details.publicAid.add',
  addCaption: 'afforda.wagesAndIncome.details.publicAid.addDescription',
};

export const PUBLIC_AID_FIELD_NAMES = {
  id: WAGES_AND_INCOME_COMMON_FIELD_NAMES.id,
  annualAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  monthlyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  payFrequency: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  source: WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  weeklyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    [PUBLIC_AID_FIELD_NAMES.id]: item.id,
    [PUBLIC_AID_FIELD_NAMES.payFrequency]: item.payFrequency ?? '',
    [PUBLIC_AID_FIELD_NAMES.weeklyAmount]: item.weeklyAmount ?? '',
    [PUBLIC_AID_FIELD_NAMES.monthlyAmount]: item.monthlyAmount ?? '',
    [PUBLIC_AID_FIELD_NAMES.annualAmount]: item.annualAmount ?? '',
  };
};

export const NEW_PUBLIC_ASSISTANCE = {
  [PUBLIC_AID_FIELD_NAMES.id]: '',
  [PUBLIC_AID_FIELD_NAMES.memberId]: '',
  [PUBLIC_AID_FIELD_NAMES.payFrequency]: '',
  [PUBLIC_AID_FIELD_NAMES.weeklyAmount]: '',
  [PUBLIC_AID_FIELD_NAMES.monthlyAmount]: '',
  [PUBLIC_AID_FIELD_NAMES.annualAmount]: '',
};

export const FIELDS = ({ members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    ...FIELD_SET_COMMON_PAY_FREQUENCY,
  ];
};
